.d2{outline:none;}